<script setup lang="ts">
import { useAttrs } from 'vue';

interface Props {
  disabled?: boolean;
}

const props = defineProps<Props>();

const model = defineModel<boolean>();

const attrs = useAttrs();
</script>

<template>
  <label class="label" :class="{ disabled: props.disabled }">
    <input v-bind="attrs" v-model="model" type="checkbox" />
    <span
      class="checkbox"
      :class="{
        checked: model,
      }"
    >
      <icon size="20px" name="icons:check" class="icon" />
    </span>
  </label>
</template>

<style scoped>
.label {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.label span,
.label input {
  cursor: pointer;
}

input {
  position: absolute;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 3.5px;
  border: 1px solid var(--main-blue);
  transition: background-color 0.3s ease, border 0.3s ease;
}

.checked {
  background-color: var(--main-blue);
}

.icon {
  pointer-events: none !important;
  flex-shrink: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.checked .icon {
  opacity: 1;
  visibility: visible;
  filter: blur(0) !important;
}

.checkbox:hover {
  background-color: var(--main-blue);
}

.checkbox:hover .icon {
  opacity: 1;
  visibility: visible;
  filter: blur(2px);
}
</style>
